import styled, { createGlobalStyle } from "styled-components";

// Altura total da barra: line-height (20) + padding vertical (6 + 6) = 32px.
const BANNER_HEIGHT = "32px";

// Enquanto a barra está ativa, reserva um espaço no fim da página com a mesma
// altura dela, para que o conteúdo do rodapé (footer) não fique escondido sob
// a barra fixa. Como é renderizada junto com a barra, o espaço só existe quando
// o banner está ativo.
export const BannerSpacing = createGlobalStyle`
  body {
    padding-bottom: ${BANNER_HEIGHT};
  }
`;

// Cores fixas (independentes do tema): a barra de aviso de ambiente precisa
// renderizar de forma idêntica em qualquer tema (common, admin, etc.).
export const Bar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: ${BANNER_HEIGHT};
  box-sizing: border-box;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: 6px 16px;
  background-color: #a81423;
  color: #ffffff;

  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;

  /* Não bloqueia cliques em elementos sob a barra (ex.: footer) */
  pointer-events: none;
  user-select: none;
`;
